/**
 * Art. 50 Abs. 2 KI-VO — the query-parameter lanes of the AI mark.
 *
 * Request bodies that ARE the entity (offering, treatments, lanes, speaker,
 * additional field, furniture bulk, workflow …) and the multipart creates
 * (event create, template apply — `new ObjectMapper()` refuses unknown body
 * fields) cannot carry a write-only body field, so the AI tool behind the
 * write travels as `?aiContentTool=<tool>` (plan rev. 4.2, "Regel
 * Request-Formen"). Template writes that copy content out of another event
 * name that event as `?sourceEventId=<id>` so the server can copy ITS mark.
 *
 * A missing / empty value adds nothing: the URL stays byte-identical to the
 * pre-mark call, so every untouched caller keeps its exact request.
 */
function withQueryParam(path: string, name: string, value: string | null | undefined): string {
  if (typeof value !== "string" || value.trim().length === 0) return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}${name}=${encodeURIComponent(value)}`;
}

/** `path` plus `?aiContentTool=<tool>` when a tool is given. */
export function withAiContentTool(path: string, aiContentTool: string | null | undefined): string {
  return withQueryParam(path, "aiContentTool", aiContentTool);
}

/** `path` plus `?sourceEventId=<id>` when an id is given (J6, template writes). */
export function withSourceEventId(path: string, sourceEventId: string | null | undefined): string {
  return withQueryParam(path, "sourceEventId", sourceEventId);
}
